export default "__VITE_ASSET__ClA4OVC3__"